import React, { useCallback } from 'react'
import { Link } from 'gatsby'
import { fireEvent } from '@/utils/activityLog'
import { useGetCurrentPath } from '@/utils/hooks/useGetCurrentPath'
import { CreatedAt, Category } from '@/components/atoms/entrypoint'
import * as style from './index.module.css'

interface Props {
  node: {
    /** ニュースのid */
    newsId: string
    /** ニュースのタイトル */
    title: string
    /** ニュースのカテゴリー */
    category: string
    /** ニュースの画像 */
    thumbnail: {
      url: string
    }
    /** ニュースの作成日 */
    createdAt: string
  }
}

/**
 * @file Newsの共通components
 */
export const News = ({ node }: Props): React.JSX.Element => {
  const { currentPath } = useGetCurrentPath()
  const { newsId, title, category, thumbnail, createdAt } = node

  const onClickNews = useCallback((): void => {
    fireEvent({
      event: 'clickNewsId',
      parameters: {
        news_id: newsId,
        news_title: title,
        current_path: currentPath,
      },
    })
  }, [newsId, title, currentPath])

  return (
    <Link className={style.link} to={`/news/${newsId}`} onClick={onClickNews}>
      <div className={style.root} aria-label={`「${title}」の記事を読む`}>
        <img
          className={style.img}
          src={thumbnail.url}
          alt={`${title}のサムネイル`}
        />
        <div className={style.content}>
          <div className={style.subContent}>
            <CreatedAt createdAt={createdAt} />
            <Category category={category} />
          </div>
          <h3 className={style.title}>{title}</h3>
          <div className={style.linkText}>記事を読む</div>
        </div>
      </div>
    </Link>
  )
}
